<app-uat-flag></app-uat-flag> 
<app-loader></app-loader>
<app-header></app-header>
<div class="main">
    <router-outlet></router-outlet>
</div>